import { Button, FormGroup, Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { ItemPredicate } from '@blueprintjs/select'
import React, { Component, MouseEvent } from 'react'

import { SyncIndicator } from './sync-indicator'
import { createHelperText, createLabelWithId, createRequiredLabel, getIntent, identity } from './utils'

import { LookupOption, MultiselectOption, MultiselectWrapper } from '../../app/shared'
import { FieldArrayAdapterProps, MultiselectProps } from './types'

type StateProps = {
  options: LookupOption[]
}

type OwnProps = {
  openOnKeyDown?: boolean
}

type Props = FieldArrayAdapterProps<MultiselectProps> & StateProps & OwnProps

export class MultiselectAdapterSimple extends Component<Props> {
  render() {
    const {
      fields,
      meta,
      openOnKeyDown,
      disabled = false,
      required,
      options,
      label,
      inline,
      intent,
      helperText,
      translate = identity,
      enableSyncControl,
      // tslint:disable-next-line:no-empty
      onSyncChange = (fieldName: string, newValue: boolean) => {},
    } = this.props

    const { id, labelText } = createLabelWithId(fields, label)
    const intentType = getIntent(meta, intent)
    const helperTextMessage = createHelperText(meta, helperText, translate)
    const labelInfo = createRequiredLabel(required, translate)

    const reqLabelMod = (
      <>
        {labelInfo}
        {enableSyncControl && (
          <SyncIndicator
            translate={translate}
            fieldName={fields.name}
            disabled={disabled}
            onSyncChange={onSyncChange}
          />
        )}
      </>
    )

    return (
      <FormGroup
        className={labelInfo ? 'required' : ''}
        helperText={helperTextMessage}
        label={labelText}
        labelFor={id}
        labelInfo={reqLabelMod}
        intent={intentType}
        inline={inline}
        disabled={disabled}
      >
        <MultiselectWrapper
          itemPredicate={this.itemPredicate}
          hasButton={this.isRemoveVisible}
          onAdd={this.handleAdd}
          onRemove={this.handleRemove}
          items={options}
          onInputChange={this.handleTextChange}
          selectedItems={(fields as any).value}
          translate={translate}
          isLoading={false}
          disabled={disabled}
          openOnKeyDown={openOnKeyDown}
        />
        {this.isRemoveVisible && (
          <Button
            className="multiselect-popover__button bp3-minimal bp3-small"
            icon={<Icon icon={IconNames.CROSS} title={false} />}
            onClick={this.handleReset}
            disabled={disabled}
          />
        )}
      </FormGroup>
    )
  }

  private get isRemoveVisible() {
    return (this.props.fields as any).length > 0
  }

  private handleAdd = (item: MultiselectOption) => {
    this.props.fields.push(item)
  }

  private handleRemove = (index: number) => {
    this.props.fields.remove(index)
  }

  private handleReset = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()

    const length = (this.props.fields as any).length
    for (let i = length; i > 0; i--) {
      this.props.fields.remove(i - 1)
    }
  }

  private handleTextChange = (query: string) => {
    return
  }

  private itemPredicate: ItemPredicate<MultiselectOption> = (query, option) => {
    return `${option.name.toLowerCase()}`.indexOf(query.toLowerCase()) >= 0
  }
}



// WEBPACK FOOTER //
// ./src/modules/forms/mutliselect-adapter-simple.tsx